import React, { useRef } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

export default function PowerBIEmbedComponent({ embedUrl, accessToken, reportId, embedType = 'report', pageName }) {
    
    const embeddedReportObj = useRef(null);

    if (!embedUrl || !accessToken) {
        return (
            <div className="text-center text-muted py-5">
                <p>Missing embed URL or access token</p>
            </div>
        );
    }

    const embedConfig = {
        type: embedType, // 'report', 'dashboard', 'tile', 'visual', or 'qna'
        id: reportId,
        embedUrl: embedUrl,
        accessToken: accessToken,
        tokenType: models.TokenType.Embed,
        ...(pageName && { pageName: pageName }), // Add pageName if provided
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false
                }
            },
            background: models.BackgroundType.Transparent,
        }
    };

    const eventHandlers = new Map([
        ['loaded', function () {
            console.log('Report loaded');
        }],
        ['rendered', function () {
            console.log('Report rendered');
        }],
        ['error', function (event) {
            console.error('Report error:', event.detail);
        }]
    ]);

    // Print handler
    const handlePrint = () => {
        if (embeddedReportObj.current && embeddedReportObj.current.print) {
            embeddedReportObj.current.print();
        }
    };

    return (
        <>
            <style>{`
                .report-style-class {
                    width: 100% !important;
                    height: 100% !important;
                }
            `}</style>
            <div style={{ marginBottom: '10px' }}>
                <button onClick={handlePrint} className="btn btn-primary">
                    Print Report
                </button>
            </div>
            <div style={{ height: '100%', width: '100%' }}>
                <PowerBIEmbed
                    embedConfig={embedConfig}
                    eventHandlers={eventHandlers}
                    cssClassName="report-style-class"
                    getEmbeddedComponent={(embeddedReport) => {
                        embeddedReportObj.current = embeddedReport;
                    }}
                />
            </div>
        </>
    );
}
